// extracted by mini-css-extract-plugin
module.exports = {"root":"AddAndInfoButtons_root__Jz2ys","dropdownBtn":"AddAndInfoButtons_dropdownBtn__Ain0o"};